import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const itzehoer = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "Itzehoer Partnerwerkstätten in Ihrer Nähe",
      hero: {
        title: "<strong>{{organization}}<br>Werkstatt-Buchung</strong>",
        subtitle: null,
      },
      layout: {
        backText: "Zurück zu itzehoer.de",
        navbar: {
          partnerLogo: {
            alt: "Itzehoer",
          },
        },
      },
      booking: {
        ...de_DE_formal.translation.booking,
        calendarDisclaimer:
          "Bitte beachten Sie, dass der Termin vorbehaltlich der Bestätigung durch die Zentrale des Werkstattpartners vergeben wurde. Sie erhalten hierzu vom Glaspartner zeitnah eine Rückmeldung.",
      },
      linkToHome: "https://werkstatt.repareo.de/partner/itzehoer",
    },
  },
};
